import {Typography} from "@mui/material";

export const UsageInfoContent = () => {


    return {
        title: 'Usage',
        content: (
            <>
                <Typography paragraph>
                    Usage records represent the ways in which products
                    are exhibited, distributed, consumed, or otherwise
                    utilized throughout their lifecycle.
                </Typography>

                <ul>
                    <li>
                        Usage records can represent television airings,
                        SVOD exhibition periods, AVOD windows, FAST
                        channel exhibition, theatrical engagements,
                        educational uses, airline uses, and many other
                        forms of product exploitation.
                    </li>

                    <li>
                        Usage records can also represent non-traditional
                        uses, such as a participant being nominated for
                        or receiving an award when those events have
                        contractual significance.
                    </li>

                    <li>
                        Usage data is one of the primary drivers of
                        contractual obligation calculations and is
                        frequently referenced by residual, royalty,
                        participation, and other payment models.
                    </li>

                    <li>
                        Usage records are commonly associated with
                        Products, Platforms, Licenses, Territories,
                        Markets, and exhibition periods.
                    </li>

                    <li>
                        Use the <strong>Search</strong> (magnifying glass)
                        to locate existing Usage records.
                    </li>

                    <li>
                        Use the <strong>Upload</strong> button to import
                        Usage data from external files.
                    </li>

                    <li>
                        Use the <strong>Add</strong> (+) button to create
                        a new Usage record manually.
                    </li>

                    <li>
                        Use the row menu on the left side of the grid
                        to clone, edit, or delete Usage records.
                    </li>

                    <li>
                        Files can also be <strong>Processed</strong> from
                        this screen to calculate contractual obligations
                        based on the Usage activity that has been loaded.
                    </li>

                    <li>
                        Maintaining accurate Usage data is critical
                        because it frequently serves as the triggering
                        event for obligation calculations and downstream
                        payment processing.
                    </li>
                </ul>
            </>
        )
    };

};





